import { useEffect, useState } from "react";
import { CheckCircle2, Circle } from "lucide-react";
import api from "@/lib/api";
import { PortalHeader } from "@/pages/client/_shared";
import { toast } from "sonner";

export default function ClientProgress() {
  const [data, setData] = useState(null);

  const load = () => api.get("/portal/progress").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (id) => {
    try { const { data: d } = await api.patch(`/portal/progress/${id}`); setData(d); }
    catch { toast.error("Could not update milestone"); }
  };

  return (
    <div className="fv-fade-up">
      <PortalHeader title="Progress Tracker" subtitle="Track every milestone on your journey with Fairview." />

      <div className="rounded-2xl border border-white/8 bg-[#121214] p-6 mb-6" data-testid="client-progress-summary">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-[#A1A1AA]">Overall completion</span>
          <span className="text-2xl font-heading text-white">{data?.pct ?? 0}%</span>
        </div>
        <div className="h-2.5 rounded-full bg-white/8 overflow-hidden">
          <div className="h-full fv-gold-gradient transition-all duration-700" style={{ width: `${data?.pct ?? 0}%` }} />
        </div>
      </div>

      <div className="space-y-3" data-testid="client-milestones">
        {(data?.milestones || []).map((m) => (
          <button key={m.id} onClick={() => toggle(m.id)} data-testid={`client-milestone-${m.id}`}
            className="w-full flex items-start gap-4 text-left rounded-xl border border-white/8 bg-[#121214] p-4 hover:border-[#D4AF37]/30 transition-colors">
            {m.done ? <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0 mt-0.5" />
                    : <Circle className="w-6 h-6 text-[#52525B] shrink-0 mt-0.5" />}
            <div><div className={`font-medium ${m.done ? "text-white" : "text-white"}`}>{m.title}</div>
              <p className="text-sm text-[#71717A] mt-0.5">{m.description}</p></div>
          </button>
        ))}
      </div>
    </div>
  );
}
